import { render, staticRenderFns } from "./AutoCampaigns.vue?vue&type=template&id=5b7a8480&"
import script from "./AutoCampaigns.vue?vue&type=script&lang=js&"
export * from "./AutoCampaigns.vue?vue&type=script&lang=js&"
import style0 from "./AutoCampaigns.vue?vue&type=style&index=0&id=5b7a8480&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports